var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBootcampjsduration2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vwrvcz0gya)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#o1h4dnyikb)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.625 10.292c0 2.968 0 4.453-.756 5.493-.244.336-.54.632-.876.876-1.04.756-2.524.756-5.493.756-2.969 0-4.453 0-5.493-.756a3.959 3.959 0 0 1-.876-.876c-.756-1.04-.756-2.525-.756-5.493V8.709c0-.665 0-1.255.008-1.782h.056c.675 0 1.085 0 1.44-.056a4.552 4.552 0 0 0 3.784-3.784c.056-.354.056-.765.056-1.44v-.055c.527-.009 1.117-.009 1.781-.009 2.969 0 4.453 0 5.493.756.336.245.632.54.876.876.756 1.04.756 2.525.756 5.494v1.583z",
    fill: "url(#xn867riztc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.693 5.698c-.244.039-.546.042-1.266.042.074-1.14.257-1.91.704-2.525.244-.336.54-.631.876-.876.615-.446 1.385-.629 2.524-.704 0 .72-.003 1.022-.041 1.266a3.365 3.365 0 0 1-2.797 2.797z",
    fill: "url(#9xfev5hdod)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.383 6.427h-.492l-.007.492c-.009.531-.009 1.125-.009 1.786v1.617c0 1.459 0 2.594.097 3.493.1.915.304 1.644.754 2.264.275.378.608.711.987.986.62.45 1.349.655 2.263.754.9.098 2.035.098 3.494.098h.06c1.459 0 2.594 0 3.494-.098.914-.099 1.644-.303 2.263-.754.379-.275.711-.608.986-.986.45-.62.655-1.349.755-2.264.097-.899.097-2.034.097-3.493V8.678c0-1.458 0-2.594-.097-3.493-.1-.915-.304-1.644-.755-2.264l-.404.294.404-.294a4.458 4.458 0 0 0-.986-.986l-.291.4.291-.4c-.62-.45-1.349-.655-2.264-.754-.899-.098-2.034-.098-3.493-.098h-.033c-.662 0-1.255 0-1.786.009l-.492.008v.547c0 .691-.002 1.056-.05 1.362A4.052 4.052 0 0 1 3.8 6.377c-.307.049-.672.05-1.362.05h0-.056zm1.388-.235-.078-.494.078.494A3.865 3.865 0 0 0 6.984 2.98L6.49 2.9l.494.079c.046-.293.047-.642.047-1.345v-.534l-.532.035c-1.168.077-2.055.267-2.786.799a4.458 4.458 0 0 0-.987.986c-.531.732-.722 1.619-.798 2.786l-.035.533h.534c.702 0 1.052-.001 1.344-.048z",
    stroke: "url(#3gewzy1lte)",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#lqzd9enc6f)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.292 7.323a.594.594 0 0 0 0 1.188h2.375a.594.594 0 0 0 0-1.188h-2.375zM6.334 10.49a.594.594 0 1 0 0 1.187h6.333a.594.594 0 1 0 0-1.187H6.334z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "xn867riztc",
    x1: 9.5,
    y1: 1.583,
    x2: 9.5,
    y2: 17.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF30",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9xfev5hdod",
    x1: 9.5,
    y1: 1.583,
    x2: 9.5,
    y2: 17.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF30",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3gewzy1lte",
    x1: 2.375,
    y1: 1.583,
    x2: 18.127,
    y2: 15.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "o1h4dnyikb",
    x: -22.641,
    y: -23.433,
    width: 64.266,
    height: 65.85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_402_2556"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_402_2556",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lqzd9enc6f",
    x: 2.74,
    y: 4.323,
    width: 23.521,
    height: 20.354,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_2556"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_2556",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vwrvcz0gya"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h19v19H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootcampjsduration2);
export default __webpack_public_path__ + "static/media/Bootcamp js duration 2.5bfdec5da73183c52b4009edecd65b42.svg";
export { ForwardRef as ReactComponent };